export default class ModalMfFilterClassController {
	/* @ngInject */
	/**
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('../mf.controller').default} mf
	 */
	constructor(
		$timeout,
		$uibModalInstance,
		mf,
	) {
		this.$timeout = $timeout;
		this.$uibModalInstance = $uibModalInstance;

		/** @type {any} */
		this.mf = mf;
	}

	submit() {
		this.$uibModalInstance.close();
	}
}
